import { Input, Card, Layout, Row, Col } from 'antd';
import { useEffect, useState } from 'react'

MapInput = ({ initialValue, inputValidator=((e)-> true), form, field, onChange, ...props }) ->

  [map, setMap] = useState(initialValue)

  useEffect(->
    setMap(initialValue)
  , [initialValue])

  updateMap = (k, v) ->
    _map = {...map}
    _map[k] = v
    if form and field
      form.setFieldsValue({
        ...form.getFieldsValue()
        [field]: _map
      })
    setMap(_map)

  <Card size="small">
    <Layout style={{backgroundColor: 'var(--background)'}}>
    {
      Object.keys(map).map((key, i) ->
        <Row
          align="middle"
          key={key + i}
          style={{ margin: "5px 0px" }}
        >
          <Col flex={1} style={{ display: "flex", justifyContent: "center"}}>
            { key }:
          </Col>
          <Col flex={7}>
            <Input
              value={map[key]}
              onChange={(e)-> updateMap(key, e.target.value)}
            />
          </Col>
        </Row>
      )
    }
    </Layout>
  </Card>

export default MapInput
